import FontAwesomeIcon from "./FontAwesomeIcon";

export default function PencilIcon({ ...props }) {
  return <FontAwesomeIcon name="pencil" {...props} />;
}
